<template>
    <div class="pt-2 pl-2 pr-md-1 pr-2">
        <v-row no-gutters>
            <v-col :order-md="0" :order="1" md="7" cols="12" class="px-1">
                <v-card class="default_card_wm elevation-0 pt-2">
                    <DocumentMenu
                        :MenuOptions="documentMenuOptions"
                        @back="back()"
                        @zoom-in="zoomManager.zoomIn()"
                        @zoom-out="zoomManager.zoomOut()"
                        @reset-zoom="zoomManager.resetZoom()"
                        @rotate-left="
                            documentPdfRotation = rotate('left', zoomManager, documentPdfRotation)
                        "
                        @rotate-right="
                            documentPdfRotation = rotate('right', zoomManager, documentPdfRotation)
                        "
                        @download="startDownloadFile()"
                        @analyse="analyseDocumentDialog = true"
                        @delete="deleteDocumentDialog = true"
                    />
                    <v-row no-gutters>
                        <!--
                        <v-col cols="6">
                            <v-btn-back
                                @click.stop="back()"
                                v-if="
                                    mode !== 'GeneralLedger' &&
                                    !$vuetify.display.mobile &&
                                    goBackHistory
                                "
                                data-cy="document-back"
                            />
                            <v-btn-icon
                                icon="$oss-zoom-out"
                                :disabled="zoomManager.disableZoomOut()"
                                class="btn mr-1"
                                @click.stop="zoomManager.zoomOut()"
                                v-if="showZoomActions"
                            />
                            <v-btn-icon
                                icon="$oss-focus"
                                :disabled="zoomManager.disableResetZoom()"
                                class="btn mx-1"
                                @click.stop="zoomManager.resetZoom()"
                                v-if="showZoomActions"
                            />
                            <v-btn-icon
                                icon="$oss-zoom-in"
                                :disabled="zoomManager.disableZoomIn()"
                                class="btn ml-1"
                                @click.stop="zoomManager.zoomIn()"
                                v-if="showZoomActions"
                            />

                            <v-btn-icon
                                class="my-0 mr-1"
                                @click.stop="
                                    documentPdfRotation = rotate(
                                        'left',
                                        zoomManager,
                                        documentPdfRotation,
                                    )
                                "
                                icon="$fa-undo"
                            >
                            </v-btn-icon>
                            <v-btn-icon
                                class="my-0"
                                @click.stop="
                                    documentPdfRotation = rotate(
                                        'right',
                                        zoomManager,
                                        documentPdfRotation,
                                    )
                                "
                                icon="$fa-redo"
                            >
                            </v-btn-icon>
                        </v-col>
                        <v-col cols="6" class="d-flex justify-end">
                            <v-btn-icon
                                icon="$oss-download"
                                class="mx-1"
                                @click="startDownloadFile"
                            />
                            <v-menu offset-y>
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon icon="$dots_vertical" v-bind="props" class="mx-1" />
                                </template>
                                <v-list nav rounded="xl">
                                    <v-list-item
                                        @click="analyseDocumentDialog = true"
                                        v-if="restartAnalysis"
                                    >
                                        <v-list-item-title>Relancer l'analyse</v-list-item-title>
                                        <v-list-item-action>
                                            <v-icon small>$oss-scan</v-icon>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <div style="height: fit-content" >
                                        <v-list-item
                                            @click="deleteDocumentDialog = true"
                                            :disabled="disabledDelete"
                                            color="error"
                                            :active="!disabledDelete"
                                        >
                                            <v-list-item-title>Supprimer</v-list-item-title>
                                            <template v-slot:append>
                                                <v-icon size="small">$oss-trash</v-icon>
                                            </template>
                                        </v-list-item>
                                        <v-tooltip
                                            v-if="editionMessage && editionMessage.length"
                                            location="bottom"
                                            activator="parent"
                                        >
                                            <div v-html="editionMessage" />
                                        </v-tooltip>
                                    </div>
                                </v-list>
                            </v-menu>
                        </v-col>
                        -->
                        <v-col cols="12" v-if="isPDF" class="d-flex justify-center">
                            <ossPdf :rotation="documentPdfRotation" :documentId="document.id" />
                        </v-col>
                        <v-col cols="12" v-else-if="isCSV" class="d-flex justify-center">
                            <!-- {{ bankTransactions }} -->
                            <v-list style="background-color: transparent" width="100%" lines="two">
                                <v-virtual-scroll
                                    :item-height="75"
                                    :items="bankTransactions"
                                    height="700"
                                    class="py-3"
                                    bench="2"
                                >
                                    <template v-slot="{ item }">
                                        <v-list-item
                                            :key="item.id"
                                            class="oss-list-item"
                                            style="background: rgb(246 246 246) !important"
                                            :active="false"
                                            :link="false"
                                        >
                                            <v-row no-gutters>
                                                <v-col cols="10">
                                                    <v-row no-gutters>
                                                        <v-col
                                                            cols="12"
                                                            class="d-flex pb-2 font-weight-bold align-center"
                                                        >
                                                            <v-icon left color="secondary"
                                                                >$label</v-icon
                                                            >
                                                            <div
                                                                style="
                                                                    white-space: nowrap;
                                                                    overflow: hidden;
                                                                    text-overflow: ellipsis;
                                                                    width: 50vw;
                                                                "
                                                            >
                                                                {{ item.wordingOriginal }}
                                                            </div>
                                                        </v-col>
                                                        <v-col
                                                            cols="4"
                                                            class="px-1 d-flex align-center"
                                                        >
                                                            <v-icon
                                                                size="small"
                                                                left
                                                                color="secondary"
                                                                >$euro</v-icon
                                                            >{{
                                                                newCommonFormatCurrency(
                                                                    item.amount,
                                                                    undefined,
                                                                )
                                                            }}
                                                        </v-col>
                                                        <v-col
                                                            cols="4"
                                                            class="px-1 d-flex align-center"
                                                        >
                                                            <v-icon
                                                                color="secondary"
                                                                size="small"
                                                                location="start"
                                                                >$oss-calendar</v-icon
                                                            >{{ formatDate(item.dateDebit) }}
                                                        </v-col>
                                                        <v-col
                                                            cols="4"
                                                            class="px-1 d-flex align-center"
                                                            v-if="item.dateRealization"
                                                        >
                                                            <v-icon
                                                                size="small"
                                                                left
                                                                color="secondary"
                                                                >$fa-hourglass-half</v-icon
                                                            >{{ formatDate(item.dateRealization) }}
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-list-item>
                                    </template>
                                </v-virtual-scroll>
                            </v-list>
                        </v-col>
                        <v-col
                            cols="12"
                            style="max-height: 85vh; overflow-y: auto"
                            v-else-if="document.signedUrl"
                        >
                            <div
                                style="
                                    position: relative;
                                    width: 100%;
                                    height: 0;
                                    padding: 0;
                                    padding-bottom: 141.4516129032258%;
                                    margin-bottom: 50px;
                                "
                            >
                                <svg
                                    id="svg-document-miscellaneous"
                                    v-if="document"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="100%"
                                    :viewBox="`0 0 ${imageWidth} ${imageHeight}`"
                                    style="
                                        position: absolute;
                                        width: 100%;
                                        left: 0;
                                        top: 0;
                                        background: #fff;
                                    "
                                >
                                    <image
                                        id="svg-image-document-miscellaneous"
                                        :xlink:href="document.signedUrl"
                                        x="0"
                                        y="0"
                                        :height="`${imageHeight}px`"
                                        :width="`${imageWidth}px`"
                                    />
                                </svg>
                            </div>
                        </v-col>
                        <v-col
                            cols="12"
                            style="max-height: 85vh; overflow-y: auto; margin: auto 0"
                            v-else
                        >
                            <v-alert type="error">
                                Pas de prévisualisation disponible pour ce document
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-card>
                <v-list v-if="associatedFields.show" :style="svgPosition">
                    <v-list-item
                        v-for="(field, key, index) in associatedFields.fields"
                        :key="`field-${document.id}-${key}-${index}`"
                        @click="onFieldAssociation(field, key)"
                        class="oss-list-item"
                    >
                    </v-list-item>
                </v-list>
            </v-col>
            <v-col
                :order-md="1"
                :order="0"
                md="5"
                cols="12"
                :class="{ 'my-0 px-1': true, 'mb-3': $vuetify.display.mobile }"
            >
                <v-card
                    :style="
                        !$vuetify.display.mobile
                            ? {
                                  'border-top-right-radius': '0px !important',
                                  'border-bottom-right-radius': '0px !important',
                              }
                            : ''
                    "
                    class="default_card_wm fill-height elevation-0 rounded-l-0"
                >
                    <v-card-title class="d-flex flex-row title" v-if="$vuetify.display.mobile">
                        <v-btn-back
                            @click.stop="back()"
                            v-if="mode !== 'GeneralLedger'"
                            data-cy="document-back"
                            class="mr-3"
                        />
                        Détails du document
                    </v-card-title>
                    <v-card-text class="pt-0">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-list single-line class="pt-0" density="compact">
                                    <v-list-item
                                        :ripple="false"
                                        class="oss-list-item mb-2"
                                        color="success"
                                    >
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters>
                                                <v-col
                                                    cols="3"
                                                    class="d-flex align-center"
                                                    style="border-right: 1px #ededed solid"
                                                >
                                                    <b>Statut</b>
                                                </v-col>
                                                <v-col cols="6" class="d-flex align-center pl-2">
                                                    <div
                                                        v-if="
                                                            document.errorMessage &&
                                                            reUploadDocument
                                                        "
                                                        style="color: red"
                                                    >
                                                        Erreur : {{ document.errorMessage }}
                                                    </div>
                                                    <div
                                                        v-else-if="document.errorMessage"
                                                        style="color: red"
                                                    >
                                                        Erreur de lecture du fichier : contacter
                                                        votre cabinet
                                                    </div>
                                                    <div v-else-if="document.type === 'UNKNOWN'">
                                                        Choisissez le type du document
                                                    </div>
                                                    <div
                                                        v-else-if="
                                                            document.status === 'ORIGINAL_UPLOADED'
                                                        "
                                                    >
                                                        En attente d'analyse
                                                    </div>
                                                    <div v-else-if="document.status === 'UPLOADED'">
                                                        En attente d'analyse
                                                    </div>
                                                    <div v-else>OK</div>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mt-2">
                            <v-col cols="12" class="d-flex justify-center align-center py-1">
                                <v-text-field-filled
                                    v-model="document.displayName"
                                    label="Nom du document"
                                    outlined
                                    hide-details
                                    density="compact"
                                />
                            </v-col>
                            <v-col cols="12">
                                <oss-date-picker-filled
                                    :model-value="date"
                                    @change-date="onDateChanged"
                                    :textFieldReadOnly="false"
                                    :hideDetails="true"
                                    label="Date"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                class="d-flex justify-center align-center py-1"
                                v-if="currentUser.profile.configuration.document.write"
                            >
                                <v-select-filled
                                    v-model="documentType"
                                    :items="documentTypes"
                                    item-value="value"
                                    label="Type de document"
                                    outlined
                                    hide-details
                                    density="compact"
                                    :item-title="(item) => item.label"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                class="d-flex py-1"
                                v-if="
                                    (documentType === 'CURRENT_ACCOUNT' ||
                                        documentType === 'OPERATOR_ACCOUNT') &&
                                    !isAutonomousUser
                                "
                            >
                                <v-select-filled
                                    v-model="currentAccountUser"
                                    :items="currentAccountUsers"
                                    :item-title="getUserDisplayName"
                                    item-value="id"
                                    label="Associé"
                                    style="margin: 0 auto"
                                    return-object
                                    outlined
                                    density="compact"
                                />
                            </v-col>
                            <v-col
                                v-if="
                                    activateTagguing && document.type !== 'EXPENSE_REPORT_DOCUMENT'
                                "
                            >
                                <FreeTag
                                    :companyTags="allCompanyTags"
                                    :document="inDocument"
                                    :splitUserPartitions="true"
                                    @changed="startToBeDoneIfNecessary"
                                />
                            </v-col>
                            <v-col cols="12" class="d-flex justify-end align-center py-3">
                                <v-btn
                                    rounded
                                    elevation="0"
                                    @click="validMiscellaneous()"
                                    size="small"
                                    >Enregistrer</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions v-if="mode !== 'GeneralLedger'">
                        <v-row no-gutters>
                            <v-col cols="3">
                                <oss-dialog
                                    v-model="switchToDocumentValidationDialog"
                                    title="Passer à la validation"
                                    @valid="switchToDocumentValidation"
                                    width="40vw"
                                >
                                    <!-- <template v-slot:activator="{ on }">
                                            <v-btn
                                                v-if="documentType === 'PURCHASE_INVOICE' || documentType === 'SALES_INVOICE' || documentType === 'EXPENSE_REPORT_DOCUMENT'"
                                                 size="small"
                                                color="primary"
                                                elevation="0"
                                                rounded
                                                v-on="on"
                                            >
                                                Passer à la validation
                                            </v-btn>
                                        </template> -->

                                    <div class="text-center">
                                        Passer ce document en mode validation
                                    </div>
                                </oss-dialog>
                                <v-btn
                                    v-if="
                                        documentType === 'PURCHASE_INVOICE' ||
                                        documentType === 'SALES_INVOICE' ||
                                        documentType === 'EXPENSE_REPORT_DOCUMENT'
                                    "
                                    elevation="0"
                                    rounded
                                    @click="switchToDocumentValidationDialog = true"
                                    size="small"
                                >
                                    Passer à la validation
                                </v-btn>
                                <!-- <v-btn
                                        v-if="documentType === 'PURCHASE_INVOICE' || documentType === 'SALES_INVOICE' || documentType === 'EXPENSE_REPORT_DOCUMENT'"
                                         size="small"
                                        color="primary"
                                        elevation="0"
                                        rounded
                                        @click="switchToDocumentValidation()"
                                    >
                                        Passer à la validation
                                    </v-btn> -->
                            </v-col>
                            <v-col cols="6" class="d-flex justify-center">
                                <v-btn-prev :disabled="previousDisabled()" @click="previous()" />
                                <v-btn-next :disabled="nextDisabled()" @click="next()" />
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <!-- <div class="text-center" v-if="!$vuetify.display.mobile">
                <div class="bottom-sheet">
                    <div class="remote">
                        <v-container class="controller" elevation-1 style="pointer-events: auto;">
                            <v-btn
                                :disabled="zoomManager.disableZoomOut() || isPDF"
                                class="btn"
                                rounded="circle" size="small"
                                color="secondary"
                                @click.stop="zoomOut()"
                            >
                                <v-icon>$zoom_out</v-icon>
                            </v-btn>
                            <v-btn
                                :disabled="zoomManager.disableResetZoom()"
                                class="btn"
                                rounded="circle" size="small"
                                color="secondary"
                                @click.stop="zoomManager.resetZoom()"
                            >
                                <v-icon>$center_focus_weak</v-icon>
                            </v-btn>
                            <v-btn
                                :disabled="zoomManager.disableZoomIn() || isPDF"
                                class="btn"
                                rounded="circle" size="small"
                                color="secondary"
                                @click.stop="zoomManager.zoomIn()"
                            >
                                <v-icon>$zoom_in</v-icon>
                            </v-btn>
                            <v-btn
                                :disabled="previousDisabled()"
                                class="btn"
                                rounded
                                 size="small"
                                color="secondary"
                                @click="previous()"
                            >
                                <v-icon>$navigate_before</v-icon>
                                <span>Précédent</span>
                            </v-btn>
                            <v-btn
                                class="btn"
                                rounded="circle" size="small"
                                color="secondary"
                                @click="stop()"
                                v-if="toBeDoneStatus"
                            >
                                <v-icon>$stop</v-icon>
                            </v-btn>
                            <v-btn
                                :disabled="nextDisabled()"
                                class="btn"
                                rounded
                                 size="small"
                                color="secondary"
                                @click="next()"
                            >
                                <span>Suivant</span>
                                <v-icon>$navigate_next</v-icon>
                            </v-btn>
                            <v-btn
                                class="btn"
                                rounded
                                 size="small"
                                color="secondary"
                                @click="openReconciliation()"
                                v-if="activateReconciliation"
                            >
                                <v-icon>$compare_arrows</v-icon>
                                <span>Rapprochement</span>
                            </v-btn>
                        </v-container>
                    </div>
                </div>
            </div> -->
        <DocumentWizardDialog
            v-model:active="activeUploadDocument"
            :companyId="companyId"
            :documentId="document.id"
            :documentType="document.type"
            :showFirstPrevious="false"
            :multiple="false"
            @fileUploaded="onFileUploaded"
        />
        <oss-dialog
            v-model="deleteDocumentDialog"
            title="Supprimer le document"
            :error="true"
            @valid="deleteDocument"
            :validTitle="'Oui je suis sûr(e)'"
            :validLoading="deleteDocumentLoading"
            width="800px"
        >
            <template v-if="editionMessage && editionMessage.length">
                <div v-html="editionMessage" />
            </template>

            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir supprimer le document ?</h4>
        </oss-dialog>
        <oss-dialog
            v-model="analyseDocumentDialog"
            title="Relancer l'analyse du document"
            @valid="analyseDocument"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir relancer l'analyse ?</h4>
        </oss-dialog>
        <Chat
            v-if="openChat"
            :id="document.chat ? document.chat.id : ''"
            :status="'INFORMATION_REQUEST'"
            :showSmartChat="false"
        />
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import { User } from "../../../../types";
import { getDBFormattedDate } from "../../services/dateServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import COMPANY_USERS from "../../graphql/user/PartOfCompanyUsers.gql";
import UPDATE_DOCUMENT_TYPE from "../../graphql/document/UpdateDocumentType.gql";
import BANK_TRANSACTIONS_IMPORT_DOCUMENT from "../../graphql/bankTransaction/BankTransactionImportDocument.gql";
import UPDATE_DOCUMENT_NAME from "../../graphql/document/UpdateDocumentName.gql";
import UPDATE_DOCUMENT_DATE from "../../graphql/document/UpdateDocumentDate.gql";

import { DocumentBase } from "./DocumentBase";
import ossPdf from "./DocumentPDF.vue";
import DocumentWizardDialog from "./DocumentWizardDialog.vue";
import Chat from "../chat/Chat.vue";
import FreeTag from "../tag/FreeTag.vue";
import { DocumentMenu } from "./DocumentMenu.vue";

import moment from "moment-timezone";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

import {
    MenuDisplayDotMenuOptions,
    MenuDisplayDownloadOptions,
    MenuDisplayOptions,
    MenuDisplayRotationOptions,
    MenuDisplayZoomOptions,
} from "@/types/documentMenu.types";

import documentMenuDisplayOptionsDefaultScheme from "@/assets/json/documentMenuMenuDisplayOptionDefaultScheme.json";

@Component({
    components: {
        DocumentWizardDialog,
        Chat,
        ossPdf,
        FreeTag,
        DocumentMenu,
    },
})
export class DocumentMiscellaneous extends DocumentBase {
    items: Array<any> = [];

    valid = false;

    loading = false;

    updating = false;

    dialogSelectCompany = false;

    activeUploadDocument = false;

    date_ = null;

    get documentMenuZoomOptions(): MenuDisplayZoomOptions {
        const zoomOptions: MenuDisplayZoomOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.zoomButtons,
        };

        zoomOptions.isDisplay = this.showZoomActions;
        zoomOptions.isResetZoomDisabled = this.zoomManager.disableResetZoom();
        zoomOptions.isZoomInDisabled = this.zoomManager.disableZoomIn();
        zoomOptions.isZoomOutDisabled = this.zoomManager.disableZoomOut();

        return zoomOptions;
    }

    get documentMenuDownloadOptions(): MenuDisplayDownloadOptions {
        const downloadButton: MenuDisplayDownloadOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.downloadButton,
        };

        downloadButton.isDisplay = true;

        return downloadButton;
    }
    get documentMenuOptionsRotateDocumentButton(): MenuDisplayRotationOptions {
        let rotationButton: MenuDisplayRotationOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.RotateDocument,
        };

        rotationButton.isDisplay = this.showRotateActions;

        return rotationButton;
    }

    get documentMenuDotMenuOptions(): MenuDisplayDotMenuOptions {
        const dotMenuOptions: MenuDisplayDotMenuOptions = {
            ...documentMenuDisplayOptionsDefaultScheme.dotMenu,
        };

        dotMenuOptions.isDisplay = true;

        dotMenuOptions.analyse.isDisplay = this.restartAnalysis;
        dotMenuOptions.analyse.title = "Relancer l'analyse";

        dotMenuOptions.delete.isDisplay = true;
        dotMenuOptions.delete.title = "Supprimer";
        dotMenuOptions.delete.disabled = this.disabledDelete;

        return dotMenuOptions;
    }

    get documentMenuOptions(): MenuDisplayOptions {
        const documentMenuOption: MenuDisplayOptions = {
            ...documentMenuDisplayOptionsDefaultScheme,
        };

        documentMenuOption.zoomButtons = this.documentMenuZoomOptions;
        documentMenuOption.RotateDocument = this.documentMenuOptionsRotateDocumentButton;
        documentMenuOption.downloadButton = this.documentMenuDownloadOptions;
        documentMenuOption.dotMenu = this.documentMenuDotMenuOptions;

        return documentMenuOption;
    }

    get date() {
        if (this.date_) {
            return this.date_;
        }
        return this.document.date;
    }

    set date(value) {
        this.date_ = value;
    }

    get reUploadDocument() {
        if (!this.document) return false;
        if (this.currentUser.profile.configuration.document.write) {
            return true;
        }
        return false;
    }

    get documentTypes() {
        const documentTypes = [];
        if (this.document.type === "UNKNOWN") {
            documentTypes.push({ label: this.$t("document.type.UNKNOWN"), value: "UNKNOWN" });
        }
        documentTypes.push({
            label: this.$t("document.type.MISCELLANEOUS"),
            value: "MISCELLANEOUS",
        });
        documentTypes.push({
            label: this.$t("document.type.BANK_STATEMENT"),
            value: "BANK_STATEMENT",
        });
        if (this.document.type !== "EXPENSE_REPORT_DOCUMENT") {
            documentTypes.push({
                label: this.$t("document.type.PURCHASE_INVOICE"),
                value: "PURCHASE_INVOICE",
            });
            if (this.declareSalesInvoices && this.selectedCompany.profile.createSalesInvoice) {
                documentTypes.push({
                    label: this.$t("document.type.SALES_INVOICE"),
                    value: "SALES_INVOICE",
                });
            }
            const reconciliationType =
                this.legalForm !== "EI" ? "CURRENT_ACCOUNT" : "OPERATOR_ACCOUNT";
            documentTypes.push({
                label: this.$t("document.type." + reconciliationType),
                value: reconciliationType,
            });
        } else {
            documentTypes.push({
                label: this.$t("document.type.EXPENSE_REPORT_DOCUMENT"),
                value: "EXPENSE_REPORT_DOCUMENT",
            });
        }
        return documentTypes;
    }

    documentType_ = "";

    get documentType() {
        if (this.documentType_) {
            return this.documentType_;
        }
        return this.document.type;
    }

    set documentType(data) {
        this.documentType_ = data;
    }

    get disabledChangeType() {
        if (this.documentType === "MISCELLANEOUS") {
            return true;
        }
        if (
            (this.documentType === "CURRENT_ACCOUNT" ||
                (this.documentType === "OPERATOR_ACCOUNT" && !this.isAutonomousUser)) &&
            !(this.currentAccountUser && this.currentAccountUser.id)
        ) {
            return true;
        }
        return false;
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    @Apollo({
        query: COMPANY_USERS,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.users) {
                    this.currentAccountUsers = data.users;
                    this.updateCurrentAccountUser();
                }
            }
        },
    })
    currentAccountUsers: User[] = [];

    @Apollo({
        query: BANK_TRANSACTIONS_IMPORT_DOCUMENT,
        variables() {
            return {
                companyId: this.companyId,
                documentId: this.documentId,
            };
        },
        skip() {
            return !this.isCSV;
        },
    })
    bankTransactions: any = [];

    updateCurrentAccountUser() {
        const currentAccountUsers = this.getUsers();
        if (currentAccountUsers.length) {
            if (this.inDocument.owner) {
                const foundUser = currentAccountUsers.find(
                    (u) => u.id === this.inDocument.owner.id,
                );
                if (foundUser) {
                    this.currentAccountUser = foundUser;
                } else {
                    this.currentAccountUser = currentAccountUsers[0];
                }
            } else {
                this.currentAccountUser = currentAccountUsers[0];
            }
        } else {
            this.currentAccountUser = this.defaultUser;
        }
    }

    onFileUploaded() {
        // this.uploadFileLoading = false;
    }

    @Watch("documentId")
    async onDocumentChanged(prev, next) {
        await this.onDocumentChangedCommon(prev, next);
        if (prev !== next) {
            if (!this.document.displayName) {
                this.document.displayName = this.document.name;
            }
            this.finishMounted();
        }
    }

    beforeMount() {
        this.svgSuffix = "document-miscellaneous";
        this.onDocumentChanged(this.inDocument.id, undefined);
    }

    switchToDocumentValidationDialog: boolean = false;

    async switchToDocumentValidation() {
        await this.updateDocument("ANALYSED");
        this.$emit("edit", {
            documentId: this.documentId,
        });
        this.switchToDocumentValidationDialog = false;
    }

    formatOrderBy() {
        const fieldName = this.pagination.sortBy[0] || "type";
        let direction = "";
        if (fieldName !== "updatedAt") {
            direction = this.pagination.descending[0] ? "_DESC" : "_ASC";
        } else {
            direction = this.pagination.descending[0] ? "_ASC" : "_DESC";
        }
        return fieldName + direction;
    }

    async updateDocument(status) {
        await this.$apollo.mutate({
            mutation: UPDATE_DOCUMENT_NAME,
            variables: {
                id: this.document.id,
                name: this.document.displayName,
            },
        });
        if (!this.disabledChangeType) {
            await this.$apollo.mutate({
                mutation: UPDATE_DOCUMENT_TYPE,
                variables: {
                    id: this.document.id,
                    type: this.documentType,
                    owner: this.currentAccountUser.id
                        ? { connect: { id: this.currentAccountUser.id } }
                        : undefined,
                    status,
                },
            });
            if (this.documentType !== "MISCELLANEOUS") {
                await this.analyseDocument();
            }
            this.$emit("edit", {
                documentId: this.documentId,
            });
        }
    }

    async validMiscellaneous() {
        // debugger
        await this.updateDocument("ORIGINAL_UPLOADED");
        if (this.documentType !== "MISCELLANEOUS" && this.documentType !== "BANK_STATEMENT") {
            await this.analyseDocument();
        }
        this.$emit("edit", {
            documentId: this.documentId,
        });
    }

    async onDateChanged(date) {
        if (this.document && this.document.id) {
            this.date = date;
            if (moment(this.date).isValid()) {
                await this.$apollo.mutate({
                    mutation: UPDATE_DOCUMENT_DATE,
                    variables: {
                        id: this.document.id,
                        date: getDBFormattedDate(this.date),
                    },
                });

                if (this.dueDate.length === 10) {
                    try {
                        await this.createUserActivity(this.document.id, "UPDATE");
                    } catch (e) {
                        console.error(e);
                    }
                }
            }
        }
    }

    //
    // CHAT
    //
    open_chat: boolean = false;

    get openChat() {
        if (this.document.chat) {
            return true;
        }
        return this.open_chat;
    }
}

export default toNative(DocumentMiscellaneous);
</script>
<style lang="scss" scoped>
.v-input--has-state.text-red .v-label {
    animation: none !important;
    transition: none !important;
}

.theme--light.v-label {
    color: black !important;
}

.svg-pan-zoom_viewport {
    transition: transform 0.4s ease-out !important;
}

.inline-text-field {
    max-width: 140px;
    margin-right: 10px;
    display: inline-block;
}

.text-field-icon--associated {
    display: flex;
}

i.inline-icon {
    display: flex;
    height: 55px;
    width: 30px;
}

polygon.highlighted {
    fill: rgba(249, 177, 42, 0.5) !important;
}

.v-input--is-disabled {
    pointer-events: all !important;
}
</style>
